<style lang="stylus">
        .rounded-5
            border-radius 5px
        .userArea-container
            width 267px
            transition top 0.5s linear
            max-height calc(100vh - 60px)
            overflow-y overlay
            &::-webkit-scrollbar
                width 8px
                pointer-events none
                background none
            &::-webkit-scrollbar-thumb
                background #D2D3D6
                border-radius 6px
            &::-webkit-scrollbar-track
                background none
            &::-webkit-scrollbar-track-piece
                background none
            &::-webkit-scrollbar-corner
                background none
            .userArea-box
                background-color #fff
                border 1px solid #EBEBEB
                box-sizing border-box
            .userArea-title
                font-size 14px
                color #000
            .userArea-userbox
                position relative
                padding-top 24px
                padding-bottom 32px
                color #000
                .userbox-icon
                    display flex
                    justify-content center
                    background #fff
                    object-fit contain
                    .no-icon
                        width 72px
                        height 72px
                        line-height 72px
                        text-align center
                        color #7A5923
                        font-size 18px
                        background #FFF8E5
                        border-radius 50%
                    .userbox-defaulticon
                        width 72px
                        height 72px
                    img
                        width 100px
                        height 100px
                        border-radius 50%
                    .userbox-ring
                        position absolute
                        left -2px
                        top -23px
                        width 110px
                .userbox-nickname
                    margin-top 24px
                    p
                        padding 0 20px
                        text-align center
                        font-size 18px
                        line-height 24px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap

                .userbox-descrition
                    margin-top 16px
                    p
                        text-align center
                        padding 0 20px
                        font-size 14px
                        line-height 20px
                        color rgba(0, 0, 0, 0.5)
                        word-break break-word
                .userbox-btn
                    margin 0 auto
                    margin-top 32px
                    width 222px
                    height 40px
                    line-height 40px
                    text-align center
                    background var(--themeColor)
                    color #fff
                    font-size 18px
                    font-weight 700
                    user-select none
                    cursor pointer
            .userArea-badge
                display flex
                padding 20px
                margin-top 15px
                .badge-title
                    line-height 38px
                    width 60px
                .badge-box
                    display flex
                    flex-wrap wrap
                    margin-left 4px
                    li
                        width 37px
                        height 37px
                        padding 4px
                        object-fit contain
                        img
                            width 100%
            .userArea-hot
                margin-top 15px
                .hot-title
                    display flex
                    align-items center
                    width 100%
                    height 40px
                    padding 0 16px
                    font-size 14px
                    line-height 18px
                    color #000
                    border-bottom 1px solid #f1f3f4
                    .hot-title-icon
                        margin-right 4px
                .hot-container
                    display flex
                    flex-wrap wrap
                    padding 32px 16px
                    .hot-box
                        width 50%
                        text-align center
                        &:nth-child(-n+2)
                            margin-bottom 32px
                        .hot-box-num
                            font-size 18px
                            line-height 24px
                            color var(--themeColor)
                            font-weight 700
                            margin-bottom 8px
                        .hot-box-label
                            font-size 14px
                            line-height 18px
                            color  rgba(0, 0, 0, 0.5)
            .userArea-follow
                margin-top 15px
                .follow-container
                    display flex
                    flex-wrap wrap
                    .follow-box
                        width 50%
                        padding 32px 0
                        text-align center
                        position relative
                        &:after
                            position absolute
                            content ''
                            right 0
                            top 0
                            bottom 0
                            margin auto
                            display block
                            width 1px
                            height 30px
                            border-right 1px solid #E5E5E5
                        &:last-child
                            &:after
                                width 0
                                height 0
                        .follow-box-num
                            font-size 18px
                            line-height 24px
                            color var(--themeColor)
                            font-weight 700
                            margin-bottom 8px
                        .follow-box-label
                            font-size 14px
                            line-height 18px
                            color rgba(0, 0, 0, 0.5)
    .dark-theme__workbench
        .userArea-container
            &::-webkit-scrollbar
                width 8px
                pointer-events none
                background none
            &::-webkit-scrollbar-thumb
                background #484849
                border-radius 6px
            &::-webkit-scrollbar-track
                background #1e1e20
            .userArea-box
                background #333333
                border none
            .userArea-title
                color #fff
            .userArea-userbox
                color #fff
                .userbox-icon
                    background #333333
                .userbox-nickname
                    p
                        color #fff
                .userbox-descrition
                    p
                        color #fff
            .userArea-hot
                .hot-title
                    color #fff
                    border-bottom 1px solid #222222
                .hot-container
                    display flex
                    flex-wrap wrap
                    padding 32px 16px
                    .hot-box
                        .hot-box-num
                            color #037FFF
                        .hot-box-label
                            font-size 14px
                            line-height 18px
                            color  rgba(255, 255, 255, 0.8)
            .userArea-follow
                .follow-container
                    .follow-box
                        &:after
                            border-right 1px solid #222222
                        .follow-box-num
                            color #037FFF
                        .follow-box-label
                            color rgba(255, 255, 255, 0.8)
                        &:last-child
                            &:after
                                width 0
                                height 0
</style>
<style>
    .information-medal-offical {
        background: #fff;
        margin: 0;
        padding: 6px 12px 0;
        font-size: 12px;
        display: flex;
        flex-direction: column;
    }
    .information-medal-offical li:last-child {
        height: 42px;
        padding-bottom: 6px;
        border-bottom: 1px solid #ebebeb;
    }
    .information-medal-offical.no-ordinary li:last-child {
        border-bottom: 0;
    }
    .information-medal-offical li {
        width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
    }
    .information-medal-offical li img {
        width: 20px;
        height: 20px;
        margin: 0 4px;
    }
    .information-medal-offical li span {
        font-size: 12px;
        margin-left: 4px;
    }
    .information-medal-ordinary {
        background: #fff;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 8px;
    }
    .information-medal-ordinary li {
        width: 33.3%;
        height: 72px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .information-medal-ordinary li img {
        width: 32px;
        height: 32px;
        margin: 8px 4px;
    }
    .information-medal-ordinary li span {
        font-size: 12px;
        line-height: 12px;
    }
    .dark-theme__workbench .information-medal-offical,
    .dark-theme__workbench .information-medal-ordinary {
        background-color: #333;
        color: #fff;
    }
</style>

<template>
    <div class="userArea-container">
        <div class="userArea-userbox userArea-box rounded-5">
            <div class="userbox-icon">
                <div v-if="!avatar" class="no-icon" v-else-if="userInfo">{{ getFirstName() }}</div>
                <img v-else :src="avatar" alt="" />
            </div>
            <div class="userbox-nickname">
                <p>{{ intervieweeUserInfo.nick_name }}</p>
            </div>
            <div class="userbox-descrition" v-show="intervieweeUserInfo.profile.length !== 0">
                <p>{{ intervieweeUserInfo.profile }}</p>
            </div>
            <div
                class="userbox-btn rounded-5"
                v-if="isViewer"
                @click="follow()"
                :style="{
                    background: showFollowBtn == 1 ? '#db5e5e' : isPCDarkMode == 2 ? '#0977ea' : 'var(--themeColor)',
                }"
            >
                {{ showFollowBtn == 1 ? $t("unFollow") : $t("follow") }}
            </div>
            <div v-else class="userbox-btn rounded-5" :style="{ background: isPCDarkMode == 2 ? '#0977ea' : 'var(--themeColor)' }" @click="editInfo">
                {{ $t("edit") }}
            </div>
        </div>
        <div v-if="medalList.length" style="height: 15px"></div>
        <ul class="information-medal-offical" v-if="officals.length" :class="{ 'no-ordinary': !ordinarys.length }">
            <li v-for="(item, index) in officals" :key="index">
                <img :src="`https://images.edrawmax.cn/${item.image_key}`" alt="medal" />
                <span>{{ item.title }}</span>
            </li>
        </ul>
        <ul class="information-medal-ordinary" v-if="ordinarys.length">
            <li v-for="(item, index) in ordinarys" :key="index">
                <img :src="`https://images.edrawmax.cn/${item.image_key}`" alt="medal" />
                <span>{{ item.title }}</span>
            </li>
        </ul>
        <div class="userArea-hot userArea-box rounded-5">
            <p class="userArea-title hot-title">
                <svg class="hot-title-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2.49998 4C4.50228 1 5.46883 0 5.46883 0C5.46883 0 6.75055 5 8.00055 5C9.25055 5 8.96883 3 8.96883 3C8.96883 3 10.4694 3.5 10.9694 6C11.4694 8.5 10.4374 12 5.96869 12C1.5 12 0.497673 7 2.49998 4Z"
                        fill="url(#hot-title-icon_linear)"
                    />
                    <defs>
                        <linearGradient id="hot-title-icon_linear" x1="6.3001" y1="0" x2="6.3001" y2="12" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#FF4D00" />
                            <stop offset="1" stop-color="#FFE5D1" />
                        </linearGradient>
                    </defs>
                </svg>
                {{ $t("hot") }}
            </p>
            <div class="hot-container">
                <div class="hot-box" v-for="item in hotData" :key="item.id">
                    <p class="hot-box-num" :id="item.name"></p>
                    <p class="hot-box-label">{{ $t(item.label) }}</p>
                </div>
            </div>
        </div>

        <div class="userArea-follow userArea-box rounded-5">
            <div class="follow-container">
                <div class="follow-box" v-for="item in followData" :key="item.id">
                    <p class="follow-box-num">{{ numFilter(item.num) }}</p>
                    <p class="follow-box-label">{{ isViewer ? $t(item.label) : $t(item.label + "_self") }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CountUp from "@/public/utils/countUp.js";
    export default {
        name: "UserArea",
        data() {
            return {
                followTimer: 0,
                medalList: [],
            };
        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo;
            },
            isViewer() {
                return this.$store.state.userInfo.user_id != this.$store.state.userPage.viewerID;
            },
            vipState() {
                return false && this.userInfo.isVip;
            },
            isFollowing() {
                return this.$store.state.userPage.isFollowing;
            },
            showFollowBtn() {
                if (this.isFollowing == -1 || !this.isFollowing) {
                    return 0;
                } else {
                    return 1;
                }
            },
            intervieweeUserInfo() {
                return this.$store.state.userPage.intervieweeUserInfo;
            },
            avatar() {
                return this.intervieweeUserInfo.avatar;
            },
            followData() {
                return this.$store.state.userPage.followData;
            },
            hotData() {
                return this.$store.state.userPage.hotData;
            },
            officals() {
                return this.medalList.filter((item) => item.type === 1);
            },
            ordinarys() {
                return this.medalList.filter((item) => item.type === 2);
            },
        },
        components: {},
        props: {},
        methods: {
            getFirstName() {
                return this.intervieweeUserInfo.nick_name.trim().split("")[0];
            },
            numFilter(num) {
                if (num > 10000) {
                    return "10k+";
                } else if (num > 1000) {
                    return ~~(num / 1000) + "k+";
                } else {
                    return num;
                }
            },
            scrollNum(id, num) {
                let option = {
                    useEasing: true,
                    useGrouping: true,
                    separator: ",",
                    decimals: 0,
                    prefix: "",
                    suffix: "",
                };
                let a = new CountUp(id, 0, num, 0, option);
                a.start();
            },
            follow() {
                if (!this.$validateLogin()) {
                    this.$store.commit("toTplCenter", {
                        name: "showUserWorks",
                        data: false,
                    });
                    return;
                }
                if (!this.$store.state.userPage.getDataDone) {
                    return;
                }
                if (this.followTimer) {
                    clearTimeout(this.followTimer);
                }
                this.followTimer = setTimeout(() => {
                    if (!this.isFollowing) {
                        if (this.isPC) {
                            this.$pcTrack(
                                JSON.stringify({
                                    type: "publish template",
                                    action: "followBlogger",
                                    event: "experience",
                                })
                            );
                        }
                    }
                    this.$store
                        .dispatch("userPage/doFollow", {
                            follow: this.showFollowBtn == 0,
                        })
                        .then(() => {
                            this.$store.dispatch("getOwnRelationships"); // 刷新主页面关注数据
                        });
                }, 350);
            },
            editInfo() {
                this.$store.commit("userPage/setState", {
                    type: "iShowEdit",
                    data: true,
                });
            },
            updateHotData(index) {
                document.getElementById(this.hotData[index].name).innerHTML = this.hotData[index].num;
            },
        },
        mounted() {
            this.$edApi.getUserMedal([this.$store.state.userPage.viewerID]).then((res) => {
                this.medalList = res?.[0]?.medal_info || [];
            });
            this.$bus.$on("updateHotData", (index) => {
                this.updateHotData(index);
            });
            setTimeout(() => {
                for (let i = 0; i < this.hotData.length; i++) {
                    this.scrollNum(this.hotData[i].name, this.hotData[i].num);
                }
            }, 300);
        },
        beforeDestroy() {
            this.$bus.$off("updateHotData");
        },
    };
</script>
<i18n>
{
  "zh": {
    "follow": "关注",
    "unFollow": "取消关注",
    "hot": "热度",
    "pv": "浏览量",
    "like": "点赞量",
    "used": "使用量",
    "collect": "收藏量",
    "followLabel": "TA关注的人",
    "fansLabel": "关注TA的人",
    "followLabel_self": "我关注的人",
    "fansLabel_self": "关注我的人",
    "edit": "编辑"
  },
  "en": {
    "follow": "Follow",
    "unFollow": "Unfollow",
    "hot": "Hot",
    "pv": "PV",
    "like": "Like",
    "used": "Used",
    "collect": "Collect",
    "followLabel": "Follow",
    "fansLabel": "Fans",
    "followLabel_self": "Follow",
    "fansLabel_self": "Fans",
    "edit": "Edit"
  },
  "kr": {
    "follow": "팔로우",
    "unFollow": "팔로우 취소",
    "hot": "인기 많은",
    "pv": "조회수",
    "like": "좋아요수",
    "used": "적용수",
    "collect": "즐겨찾기수",
    "followLabel": "팔로우한 사람",
    "fansLabel": "팔로워",
    "followLabel_self": "팔로우한 사람",
    "fansLabel_self": "팔로워",
    "edit": "편집"
  },
  "tw": {
    "follow": "關注",
    "unFollow": "取消關注",
    "hot": "熱度",
    "pv": "瀏覽量",
    "like": "點讚量",
    "used": "使用量",
    "collect": "收藏量",
    "followLabel": "TA關注的人",
    "fansLabel": "關於TA的人",
    "followLabel_self": "我關注的人",
    "fansLabel_self": "關於我的人",
    "edit": "編輯"
  },
  "jp": {
    "follow": "フォロー",
    "unFollow": "アンフォロー",
    "hot": "ホット",
    "pv": "視聴回数",
    "like": "いいね",
    "used": "ダウンロード",
    "collect": "お気に入り",
    "followLabel": "フォロー",
    "fansLabel": "ファン",
    "followLabel_self": "フォロー",
    "fansLabel_self": "ファン",
    "edit": "編集"
  },
  "id": {
    "follow": "Ikuti",
    "unFollow": "Berhenti mengikuti",
    "hot": "Populer",
    "pv": "PV",
    "like": "Suka",
    "used": "Digunakan",
    "collect": "Kumpulkan",
    "followLabel": "Ikuti",
    "fansLabel": "Penggemar",
    "followLabel_self": "Ikuti",
    "fansLabel_self": "Penggemar",
    "edit": "Edit"
  }
}
</i18n>
